/**
 * Checkout referrer utilities based on CheckoutReferrerHelper
 */

const CHECKOUT_REFERRER_KEY = 'checkoutReferrerURL';

const saveCheckoutReferrer = (): void => {
    if (typeof window !== 'undefined') {
        const pathname = new URL(window.location.href).pathname;
        window.sessionStorage.setItem(CHECKOUT_REFERRER_KEY, pathname);
    }
};

const goToCheckoutReferrer = (fallbackUrl = '/cart'): void => {
    if (typeof window !== 'undefined') {
        const referrer = window.sessionStorage.getItem(CHECKOUT_REFERRER_KEY);
        window.location.href = referrer ?? fallbackUrl;
    }
};

export const useCheckoutReferrer = () => ({
    saveCheckoutReferrer,
    goToCheckoutReferrer,
});
